import ContentCopy from '@mui/icons-material/ContentCopy';
import { Tooltip, IconButton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CopyToClipboardProps {
  disabled?: boolean;
  copiedValue: string;
}

export const CopyToClipboard = ({
  disabled,
  copiedValue,
}: CopyToClipboardProps) => {
  const { t } = useTranslation();

  const language = {
    copy: t('CopyToClipboard.copy'),
    copied: t('CopyToClipboard.copied'),
  };

  const [tooltipText, setTooltipText] = useState(language.copy);

  /**
   * Slight timeout so the text doesn't snap back to "Copy"
   * while the fade-out animation is still playing.
   */
  const handleTooltipClose = () => {
    setTimeout(() => {
      setTooltipText(language.copy);
    }, 200);
  };

  const handleCopy = async (value: string) => {
    await navigator.clipboard.writeText(value);
    setTooltipText(language.copied);
  };

  return (
    <Tooltip
      title={tooltipText}
      onClose={handleTooltipClose}
      leaveDelay={200} // Keeps the tooltip visible briefly as the mouse leaves
      arrow
    >
      <IconButton
        disabled={disabled}
        onClick={() => void handleCopy(copiedValue)}
        aria-label={language.copy}
      >
        <ContentCopy />
      </IconButton>
    </Tooltip>
  );
};
